module.exports = __webpack_public_path__ + "img/LAST_QUARTER.67dd05bc.png";